//SelfStudyHome.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../../components/utils/Tooltip';
import './styles/SelfStudy.css';
import './styles/BookShelf.css';
import selfstudyimage from '../../assets/pageimages/SelfStudy.webp';

import adImage from '../../assets/pageimages/bookworldlistad.webp';


const SelfStudyHome = () => {
    const tooltiptext = "About Think5Whys";

    return (
        <MainLayout>
            <div>
                <h3 className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>Learnings - Self Study</h3>
            </div>
            <div className="bookshelf-container w-7/12">
                <div className='relative inset-0 flex justify-center mt-2 mb-2'>
                    <img src={adImage} />
                </div>
                <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
                    <div className="button-links flex align-middle justify-center bg-gray-500">
                        <div className="bottom-buttons-box"><Link to="/selfstudy-library" className="top-button-link"><FontAwesomeIcon icon={faSchoolCircleCheck} className="selfstudy-bottomlink-style" />My Books</Link></div>
                        <div className="bottom-buttons-box"><Link to="/selfstudy-artbook" className="top-button-link"><FontAwesomeIcon icon={faBookAtlas} className="selfstudy-bottomlink-style" />My Notes</Link></div>
                        <div className="bottom-buttons-box"><Link to="/selfstudy-artbook" className="top-button-link"><FontAwesomeIcon icon={faBookAtlas} className="selfstudy-bottomlink-style" />My Reading Log</Link></div>
                        <div className="bottom-buttons-box"><Link to="/selfstudy-create-master" className="top-button-link"><FontAwesomeIcon icon={faPlusSquare} className="selfstudy-bottomlink-style" />My Test</Link></div>
                        <div className="bottom-buttons-box"><Link to="/selfstudy-changes" className="top-button-link"><FontAwesomeIcon icon={faEdit} className="selfstudy-bottomlink-style" />My Chat</Link></div>
                        <div className="bottom-buttons-box"><Link to="/selfstudy-comments" className="top-button-link"><FontAwesomeIcon icon={faComment} className="selfstudy-bottomlink-style" />My Content Links</Link></div>
                        <div className="bottom-buttons-box"><Link to="/selfstudy-followups" className="top-button-link"><FontAwesomeIcon icon={faRedo} className="selfstudy-bottomlink-style" />My Mentors</Link></div>
                    </div>
                </div>
                <div className="relative inset-0 flex border border-b-gray-300">
                    <img id="selfstudy-id" src={selfstudyimage} alt="Self Study Image" />
                </div>
            </div>
        </MainLayout>
    );
};

export default SelfStudyHome;
